// @core/api/endpoints/userprofile/update_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AvatarResponse,
  UpdateAvatarRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Update avatar
 * Updates avatar metadata such as cropping parameters or display settings. Does not replace the image itself.
 */
export async function UpdateAvatar(
  profile_id: string,
  avatar_id: string,
  data: UpdateAvatarRequest,
  options?: RequestOptions
): Promise<AvatarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/avatars/:avatar_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.put<AvatarResponse>(requestPath, data, requestOptions);
}
